import { useInjectSaga } from 'redux-injectors';
export default function useInjectedSagas(sagas) {
    if (sagas) {
        sagas.forEach((saga) => {
            useInjectSaga({ key: saga.key, saga: saga.saga });
        });
    }
}
//# sourceMappingURL=useInjectedSagas.js.map